import { useState } from "react";
import { format } from "date-fns";
import moment from "moment";
import editIcon from "../../../../assets/images/edit-icon2.svg";
import NoImage from "../../../../assets/images/no-image-avatar.png";

export default function PatientDetailsCard({
    allPatientDetails,
    childId,
    patientId,
    showKidsRef,
    showAddKidsSection,
    toggleProfileMoadl,
    navigate,
    setShowAddKidsSection,
    setEditedPhone,
    setIsEditingPhone,
    setStartUnschedulePopupOpen,
    setReschedulePopupShow,
    getDateAvailabilityList,
    userData,
    calendarValue,
    allPatientChildDetails,
    isEditingPhone,
    editedPhone,
    handleSavePhone,
    DOC_doctorId,
    isEditingAddress,
    editedAddress,
    setEditedAddress,
    handleSaveAddress,
    setIsEditingAddress,
    handleChangePriority,
    handleChangePrioritySupport,
    patientFamilyList = [],
}) {
    const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
    const primaryPatient = allPatientDetails?.data?.[0];
    const primaryContext = childId && patientId
        ? {
            ...primaryPatient,
            user_id: patientId,
            relation: "Primary patient",
        }
        : null;
    const familyContexts = patientFamilyList.filter(
        (member) => String(member?.user_id) !== String(childId),
    );
    const availableContexts = primaryContext
        ? [primaryContext, ...familyContexts]
        : familyContexts;
    const hasAvailableContexts = availableContexts.length > 0;

    return (
    <div className="Card">
        <div className="patientLeftProfile">
            {/* <h3>Full Profile</h3> */}
            <div className="patientContextSwitcher">
                <button
                    type="button"
                    className="patientContextSwitcherButton"
                    disabled={!hasAvailableContexts}
                    aria-expanded={isContextMenuOpen}
                    onClick={() => setIsContextMenuOpen((isOpen) => !isOpen)}
                >
                    Switch context
                    <span aria-hidden="true">⌄</span>
                </button>
                {isContextMenuOpen && hasAvailableContexts ? (
                    <div className="patientContextMenu" role="menu">
                        {availableContexts.map((member) => {
                            const fullName = [member?.first_name, member?.last_name]
                                .filter(Boolean)
                                .join(" ");
                            const profilePicture =
                                member?.profile_pic_url || member?.profile_picture_url || NoImage;

                            return (
                                <button
                                    type="button"
                                    role="menuitem"
                                    className="patientContextMember"
                                    key={member?.user_id}
                                    aria-label={fullName}
                                    onClick={() => {
                                        setIsContextMenuOpen(false);
                                        navigate(`/doctor/patient-dictionary/${member?.user_id}`);
                                    }}
                                >
                                    <img src={profilePicture} alt="" />
                                    <span className="patientContextMemberDetails">
                                        <strong>{fullName}</strong>
                                        <small>{member?.relation || "Family member"}</small>
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                ) : null}
            </div>
            <div className="patientLeftTopProfile">
                <div className="profileImgWrapper">
                    <img
                        src={
                            allPatientDetails?.data[0]?.profile_pic_url
                                ? allPatientDetails?.data[0]?.profile_pic_url
                                : NoImage
                        }
                        className={`profileImg ${!childId ? "active" : ""}`}
                        alt="Profile Picture"
                        onClick={() =>
                            navigate(`/doctor/patient-dictionary/${patientId}`)
                        }
                    />
                    <div className="editContWrapper" ref={showKidsRef}>
                        <button
                            className="EditButtonIcon"
                            onClick={() =>
                                setShowAddKidsSection(!showAddKidsSection)
                            }
                        ></button>
                        {showAddKidsSection ? (
                            <div className="editContainerMain">
                                <div className="editContainer">
                                    {!allPatientDetails?.data[0].id_number ? (
                                        <button
                                            onClick={() => {
                                                setEditedPhone(
                                                    allPatientDetails?.data[0]?.cell_phone ||
                                                    "",
                                                );
                                                setIsEditingPhone(true);
                                            }}
                                        >
                                            Edit Phone Number
                                        </button>
                                    ) : null}
                                    <button onClick={toggleProfileMoadl}>
                                        Add Kids
                                    </button>
                                </div>
                            </div>
                        ) : null}
                    </div>
                    {/* {allPatientDetails?.data[0]?.child_details?.length > 0
                        ? allPatientDetails?.data[0]?.child_details?.map(
                            (item, index) => (
                                <div
                                    key={index}
                                    className={`childItemsWrapper${index + 1}`}
                                >
                                    <div className="borderLine"></div>
                                    <button
                                        onClick={() =>
                                            navigate(
                                                `/doctor/patient-dictionary/${patientId}?child=${item?.id}`,
                                            )
                                        }
                                        className={
                                            parseInt(childId) === parseInt(item?.id)
                                                ? "active"
                                                : ""
                                        }
                                    >
                                        {item?.first_name} {item?.last_name}
                                    </button>
                                </div>
                            ),
                        )
                        : null} */}
                </div>
                <h4
                    onClick={() =>
                        navigate(`/doctor/patient-dictionary/${patientId}`)
                    }
                >
                    {allPatientDetails?.data[0]?.first_name}{" "}
                    {allPatientDetails?.data[0]?.last_name}
                </h4>
                <button
                    className="btn1"
                    onClick={() => {
                        setStartUnschedulePopupOpen(true);
                    }}
                >
                    Start Unscheduled
                </button>
                <button
                    className="btn2"
                    onClick={() => {
                        setReschedulePopupShow(true);
                        getDateAvailabilityList(
                            userData?.users?.id,
                            format(calendarValue, "yyyy-MM-dd"),
                            "For online consultation",
                        );
                    }}
                >
                    Schedule Appointment
                </button>
                <button
                    className="btn3"
                    style={{
                        marginTop: "8px",
                        background: "#f0f2ff",
                        color: "#687eff",
                        border: "1px solid #687eff",
                        borderRadius: "8px",
                        padding: "10px 16px",
                        cursor: "pointer",
                        width: "100%",
                        fontWeight: "500",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                    }}
                    onClick={() =>
                        navigate(`/doctor/patient-medical-report/${patientId}`)
                    }
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                        <line x1="16" y1="17" x2="8" y2="17" />
                        <polyline points="10 9 9 9 8 9" />
                    </svg>
                    Export Medical Report
                </button>
            </div>
            <div className="patientLeftBottomProfile">
                <h5>
                    Basic Info:{" "}
                    <span className="userNameText">
                        {childId && allPatientChildDetails
                            ? allPatientChildDetails?.data[0]?.first_name +
                            " " +
                            allPatientChildDetails?.data[0]?.last_name
                            : allPatientDetails?.data[0]?.first_name +
                            " " +
                            allPatientDetails?.data[0]?.last_name}
                    </span>
                </h5>
                <ul className="pflInfoList">
                    <li>
                        <div className="pflLabel">DOB:</div>
                        <div className="pflInfo">
                            {childId && allPatientChildDetails ? (
                                <>
                                    {`${allPatientChildDetails?.data[0]?.dob
                                        ? moment(
                                            allPatientChildDetails?.data[0]?.dob,
                                        ).date() +
                                        "/" +
                                        moment(
                                            allPatientChildDetails?.data[0]?.dob,
                                        ).format("MM") +
                                        "/" +
                                        moment(
                                            allPatientChildDetails?.data[0]?.dob,
                                        ).year()
                                        : ""
                                        }`}
                                </>
                            ) : (
                                <>{`${allPatientDetails?.data[0]?.dob
                                    ? moment(
                                        allPatientDetails?.data[0]?.dob,
                                    ).date() +
                                    "/" +
                                    moment(
                                        allPatientDetails?.data[0]?.dob,
                                    ).format("MM") +
                                    "/" +
                                    moment(allPatientDetails?.data[0]?.dob).year()
                                    : ""
                                    }`}</>
                            )}{" "}
                            {allPatientChildDetails?.data[0]?.age ||
                                allPatientDetails?.data[0]?.age ? (
                                <>
                                    (
                                    {childId && allPatientChildDetails
                                        ? allPatientChildDetails?.data[0]?.age
                                        : allPatientDetails?.data[0]?.age}{" "}
                                    years)
                                </>
                            ) : null}
                        </div>
                    </li>
                    <li>
                        <div className="pflLabel">Gender:</div>
                        <div className="pflInfo">
                            {childId && allPatientChildDetails
                                ? allPatientChildDetails?.data[0]?.gender
                                : allPatientDetails?.data[0]?.gender}
                        </div>
                    </li>
                    {/* <li>
                            <div className="pflLabel">Weight:</div>
                            <div className="pflInfo">74 kg</div>
                          </li>
                          <li>
                            <div className="pflLabel">Height:</div>
                            <div className="pflInfo">5’11”:</div>
                          </li> */}
                    {/* <li>
                            <div className="pflLabel">Address:</div>
                            <div className="pflInfo">{allPatientDetails?.data[0]?.city_name}</div>
                          </li> */}
                    {(childId &&
                        allPatientChildDetails?.data[0]?.show_phone) ||
                        (!childId && allPatientDetails?.data[0]?.show_phone) ? (
                        <li>
                            <div className="pflLabel">Phone:</div>
                            <div className="pflInfo">
                                {(() => {
                                    const currentPatient =
                                        childId && allPatientChildDetails
                                            ? allPatientChildDetails?.data[0]
                                            : allPatientDetails?.data[0];
                                    const currentPhone =
                                        currentPatient?.cell_phone ||
                                        currentPatient?.phone ||
                                        "";

                                    return isEditingPhone ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: "5px",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <input
                                                type="text"
                                                value={editedPhone}
                                                onChange={(e) =>
                                                    setEditedPhone(e.target.value)
                                                }
                                                className="form-control"
                                                style={{
                                                    padding: "4px 8px",
                                                    fontSize: "13px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    flex: 1,
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                onClick={handleSavePhone}
                                                style={{
                                                    border: "none",
                                                    background: "#687eff",
                                                    color: "white",
                                                    padding: "4px 8px",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={() => setIsEditingPhone(false)}
                                                style={{
                                                    border: "none",
                                                    background: "#f0f2ff",
                                                    color: "#687eff",
                                                    padding: "4px 8px",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "12px",
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            {currentPhone || "No phone"}
                                            <img
                                                src={editIcon}
                                                className="editIconCls"
                                                style={{
                                                    marginLeft: "8px",
                                                    cursor: "pointer",
                                                    width: "14px",
                                                }}
                                                onClick={() => {
                                                    setEditedPhone(currentPhone);
                                                    setIsEditingPhone(true);
                                                }}
                                            />
                                        </>
                                    );
                                })()}
                            </div>
                        </li>
                    ) : null}
                    {(() => {
                        const idNum = allPatientDetails?.data[0]?.id_number;
                        if (!idNum) return null;
                        const hasAppointment = (
                            allPatientDetails?.Appointment || []
                        ).some(
                            (item) =>
                                parseInt(item?.doctor_id) ===
                                parseInt(DOC_doctorId),
                        );
                        const display = hasAppointment
                            ? idNum
                            : idNum.length > 2
                                ? idNum[0] +
                                "*".repeat(idNum.length - 2) +
                                idNum[idNum.length - 1]
                                : idNum;
                        return (
                            <li>
                                <div className="pflLabel">Id No:</div>
                                <div className="pflInfo">{display}</div>
                            </li>
                        );
                    })()}
                    <li>
                        <div className="pflLabel">Address:</div>
                        <div className="pflInfo">
                            {isEditingAddress ? (
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "5px",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    <input
                                        type="text"
                                        value={editedAddress}
                                        onChange={(e) =>
                                            setEditedAddress(e.target.value)
                                        }
                                        className="form-control"
                                        style={{
                                            padding: "4px 8px",
                                            fontSize: "13px",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            flex: 1,
                                        }}
                                        autoFocus
                                    />
                                    <button
                                        onClick={handleSaveAddress}
                                        style={{
                                            border: "none",
                                            background: "#687eff",
                                            color: "white",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                        }}
                                    >
                                        Save
                                    </button>
                                    <button
                                        onClick={() => setIsEditingAddress(false)}
                                        style={{
                                            border: "none",
                                            background: "#f0f2ff",
                                            color: "#687eff",
                                            padding: "4px 8px",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            ) : (
                                <>
                                    {childId && allPatientChildDetails
                                        ? allPatientChildDetails?.data[0]
                                            ?.patient_address ||
                                        allPatientChildDetails?.data[0]?.address ||
                                        "No address"
                                        : allPatientDetails?.data[0]?.patient_address ||
                                        allPatientDetails?.data[0]?.address ||
                                        "No address"}
                                    <img
                                        src={editIcon}
                                        className="editIconCls"
                                        style={{
                                            marginLeft: "8px",
                                            cursor: "pointer",
                                            width: "14px",
                                        }}
                                        onClick={() => {
                                            const currentAddr =
                                                childId && allPatientChildDetails
                                                    ? allPatientChildDetails?.data[0]
                                                        ?.patient_address ||
                                                    allPatientChildDetails?.data[0]
                                                        ?.address ||
                                                    ""
                                                    : allPatientDetails?.data[0]
                                                        ?.patient_address ||
                                                    allPatientDetails?.data[0]?.address ||
                                                    "";
                                            setEditedAddress(currentAddr);
                                            setIsEditingAddress(true);
                                        }}
                                    />
                                </>
                            )}
                        </div>
                    </li>
                    <li>
                        <div className="pflLabel">Birth City:</div>
                        <div className="pflInfo">
                            {allPatientDetails?.data[0]?.birth_city_name}
                        </div>
                    </li>
                </ul>
                <ul className="PflBottomList">
                    {/* {patientFamilyList?.length > 0 ? (
                            <li className="cursorPointerCls" onClick={() => setShowFamilyPopup(true)}>
                              Family
                            </li>
                          ) : null} */}
                    <select
                        className={
                            childId && allPatientChildDetails
                                ? allPatientChildDetails?.data[0]?.priority == 1
                                    ? "prioritySelect isPriority"
                                    : "prioritySelect"
                                : allPatientDetails?.data[0]?.priority == 1
                                    ? "prioritySelect isPriority"
                                    : "prioritySelect"
                        }
                        value={
                            childId && allPatientChildDetails
                                ? allPatientChildDetails?.data[0]?.priority
                                : allPatientDetails?.data[0]?.priority
                        }
                        onChange={(e) => handleChangePriority(e.target.value)}
                    >
                        <option selected hidden>
                            Select
                        </option>
                        <option value={"1"}>Priority</option>
                        <option value={"0"}>No Priority</option>
                    </select>
                    <select
                        value={
                            childId && allPatientChildDetails
                                ? allPatientChildDetails?.data[0]?.support
                                : allPatientDetails?.data[0]?.support
                        }
                        onChange={(e) =>
                            handleChangePrioritySupport(e.target.value)
                        }
                        style={
                            (
                                childId && allPatientChildDetails
                                    ? allPatientChildDetails?.data[0]?.support
                                    : allPatientDetails?.data[0]?.support
                            )
                                ? {
                                    background: "#ffffff",
                                    border: "1px solid rgb(35 151 194)",
                                    color: "rgb(35 151 194)",
                                    borderRadius: "50px",
                                    fontFamily: "Rubik, sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    padding: "11px 10px",
                                    outline: "none",
                                    cursor: "pointer",
                                }
                                : { borderRadius: "50px" }
                        }
                    >
                        <option
                            value={""}
                            style={{
                                color: "#000000",
                                backgroundColor: "#ffffff",
                            }}
                        >
                            Select Support
                        </option>
                        <option
                            value={"Respiratory Support"}
                            style={{ backgroundColor: "red", color: "white" }}
                        >
                            Respiratory Support
                        </option>
                        <option
                            value={"Wheelchair Access"}
                            style={{
                                color: "#000000",
                                backgroundColor: "#ffffff",
                            }}
                        >
                            Wheelchair Access
                        </option>
                        <option
                            value={"Elderly Care"}
                            style={{
                                color: "#000000",
                                backgroundColor: "#ffffff",
                            }}
                        >
                            Elderly Care
                        </option>
                    </select>
                    {/* {allPatientDetails?.data[0]?.priority ? <li className="cursorPointerCls">Priority</li> : null}
                          {allPatientDetails?.data[0]?.support ? <li className="cursorPointerCls">{allPatientDetails?.data[0]?.support}</li> : null} */}
                </ul>
            </div>
        </div>
    </div>
    )
}
